import {
  IsEmail,
  IsPhoneNumber,
  IsNotEmpty,
  IsString,
  IsOptional
} from 'class-validator';
import { IBaseResponse } from './base-response.dto';

export type UserRole =
  | 'admin'
  | 'user'
  | 'developer'
  | 'pharmacy'
  | 'owner'
  | 'provider'
  | 'marketing'
  | 'provider-admin'
  | 'pharmacy-admin'
  | 'support';

export interface IAdminUser {
  _id?: string;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  phone?: string;
  emrId?: string;
  createdAt?: Date;
  permissions: {
    organization: string;
    role: UserRole;
  }[];
  services: string[];
  groups: string[];
  requireNewPassword?: boolean;
  licenses?: Array<ILicense>;
  chatIdentity?: string;
  extras?: Record<string, any>;
  docNPI?: string;
  credential?: string;
}

export interface IAdminTokenPayload extends IAdminUser {
  uid?: string;
  iat?: number;
  exp?: number;
}

// @deprecated for backward compatibility
export interface ICRMUser extends IAdminUser {}
// @deprecated for backward compatibility
export interface ICRMUserTokenPayload extends IAdminTokenPayload {}
/* -------------------------------------------------------------------------- */
/*                               Create new User                              */
/* -------------------------------------------------------------------------- */

export class CreateCRMUserDto {
  @IsNotEmpty()
  firstName: string;

  @IsNotEmpty()
  lastName: string;

  @IsNotEmpty()
  @IsEmail()
  email: string;

  @IsNotEmpty()
  @IsPhoneNumber('CA')
  phone: string;

  @IsNotEmpty()
  password: string;

  @IsString()
  @IsOptional()
  token?: string;
}

export interface CreateCRMUserResponse extends IBaseResponse {
  id: string;
}
export interface IOrgUser extends Omit<ICRMUser, 'permissions'> {
  role: string;
  permissions: null;
}

export interface IProvider {
  name: string;
  emrId: string;
}

export interface CRMUserFilters {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  _ids?: string | string[];
  [key: string]: any;
}

//------------------- EMR USER

export interface ILicense {
  grantor: string; // Ontario Physicians
  number: string; // 1040724
  label: string; // CPSO
  jurisdiction: string; // ON
  abId?: string;
  submitterId?: string;
  bcId?: string;
  skBilling?: string;
  sk?: string;
  qc?: string;
  onId?: string;
  msp?: string; //bc msp number
}
